import { render } from "./ReviewWrite.vue?vue&type=template&id=cd13c95c&scoped=true"
import script from "./ReviewWrite.vue?vue&type=script&lang=js"
export * from "./ReviewWrite.vue?vue&type=script&lang=js"

import "./ReviewWrite.vue?vue&type=style&index=0&id=cd13c95c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd13c95c"]])

export default __exports__